import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { motion } from "motion/react";

//import SettingsButton from "./SettingsButton";
import FnrShineButton from "./FnrShineButton";

export default function NetworkInfo() {
  return (
    <Wrapper>
      <FnrShineButton>
        <UserButton>
          <Photo />
          <Name>Oscar</Name>
        </UserButton>
      </FnrShineButton>
      <ButtonsHolder>
        <FnrShineButton>
          <IconHolder>
            <i className="fas fa-gear" />
          </IconHolder>
        </FnrShineButton>
        <FnrShineButton>
          <IconHolder>
            <i className="fa-solid fa-circle-question" />
          </IconHolder>
        </FnrShineButton>
        <FnrShineButton>
          <IconHolder>
            <i className="fas fa-right-from-bracket" />
          </IconHolder>
        </FnrShineButton>
      </ButtonsHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 12px;
  position: relative;
  z-index: 100;
`;
const UserButton = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 2px;
  padding: 8px;
  gap: 8px;
`;
const Photo = styled.div`
  aspect-ratio: 1;
  background: white;
  border-radius: 40px;
  height: 24px;
`;
const Name = styled.div`
  padding-right: 2px;
`;
const ButtonsHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
const IconHolder = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  text-shadow: rgba(0, 0, 0, 0.2) 1px 1px 2px;
`;
